import { isWeb } from "@helpers/platform";
import type {
	BaseItemSchema,
	Choice,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import { useMemo } from "react";
import { sessionMaxWidth } from "../../../../constants";
import HintContainer from "../../../../containers/HintContainer";
import ChoicesList from "../../../choices/ChoicesList";

type Props = {
	multiSelect?: boolean;
	isSummativeTest?: boolean;
	isAnswered?: boolean;
	selectedChoiceIds?: string[];
	correctAnswerIds?: string[];
	crossedOutChoiceIds?: string[];
	choices: Choice[];
	showHint?: boolean;
	isMobile?: boolean;
	mappedItemType?: RenderableItemTypes;
	currentItem: BaseItemSchema;
	handleSelectChoice: (choiceId: string, crossingOut?: boolean) => void;
	correctAnswerOrders?: string[];
};

const shuffleChoices = (choices: Choice[]) => {
	return choices.sort(() => Math.random() - 0.5);
};

const MCQ = ({
	multiSelect,
	isSummativeTest,
	isAnswered,
	selectedChoiceIds,
	correctAnswerIds,
	crossedOutChoiceIds,
	choices,
	showHint,
	isMobile,
	handleSelectChoice,
	currentItem,
	mappedItemType,
	correctAnswerOrders,
}: Props) => {
	const shuffle = currentItem.response?.shuffle;

	const shuffledChoices = useMemo(
		() => (shuffle ? shuffleChoices(choices) : choices),
		[choices, shuffle],
	);
	return (
		<Box gap={16}>
			<Box
				paddingHorizontal={
					(isSummativeTest && !isMobile) || (isWeb && !isMobile) ? 0 : 16
				}
				maxWidth={isSummativeTest ? sessionMaxWidth.summative : 960}
			>
				<ChoicesList
					choices={shuffledChoices}
					useCardWrapper={isSummativeTest ? isMobile : true}
					showCrossOut={!isSummativeTest}
					isAnswered={isAnswered}
					selectedChoiceIds={selectedChoiceIds}
					multiSelect={multiSelect}
					correctAnswerIds={correctAnswerIds}
					handleSelectChoice={handleSelectChoice}
					crossedOutChoiceIds={crossedOutChoiceIds}
					itemId={currentItem.id!}
					maxChoiceCount={currentItem.content?.maxChoiceCount}
					minChoiceCount={currentItem.content?.minChoiceCount}
					mappedItemType={mappedItemType}
					correctAnswerOrders={correctAnswerOrders}
					numChoicesRequired={currentItem.response?.numChoicesRequired}
				/>
			</Box>
			{showHint && choices.length > 0 && (
				<Box paddingHorizontal={isWeb && !isMobile ? 0 : 16}>
					<HintContainer key={currentItem.id} item={currentItem} />
				</Box>
			)}
		</Box>
	);
};

export default MCQ;
